import { render } from "./PrivacyPolicy.vue?vue&type=template&id=710e19c9&bindings={\"terms\":\"data\",\"errors\":\"data\",\"isLoading\":\"data\",\"prettyDate\":\"data\",\"renderToc\":\"data\",\"grants\":\"options\",\"fetchData\":\"options\"}"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"
script.render = render

export default script